import { reduxKey } from '../../constants';
import { createAction } from 'redux-actions';
export const setGlobalCounter = createAction(`${reduxKey}.DAMZ_GLOBAL_COUNTER_SET`, (count)=>({
        count
    }));
export const refreshCounter = createAction(`${reduxKey}.DAMZ_GLOBAL_COUNTER_REFRESH`, ()=>({}));

//# sourceMappingURL=counter.js.map